// ** React Imports
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import {
    Autocomplete,
    Divider,
    FormControl,
    TextField,
    Typography,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../components/ToastProvider';
import Swal from 'sweetalert2'

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const navigate = useNavigate();
    const [listData, setListData] = useState<any[]>([])
    const [listCustomer, setListCustomer] = useState<any[]>([])
    const [customer, setCustomer] = useState<any>(null)

    useEffect(() => {
        const getCustomer = () => {
            let url = apiUrl.apiUrl + '/omni/history-chat/list-customer'
    
            axios
                .get(url, {
                    params: {},
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        const data = response.data.data
                        setListCustomer(data)
                    } else {
                        showToast(response.data.message, 'error');
                    }
                })
        }
        getCustomer()
    }, [])
    const getData = () => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/omni/history-chat/list'

        axios
            .get(url, {
                params: {
                    customer_id:customer.customer_id
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            px: 2,
                            py: 1
                        }}
                    >
                        {/* Title Section */}
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                HISTORY CHAT QONTAK
                            </Typography>
                        </Box>

                        {/* Button Section */}
                        <Box>
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<Icon icon="mdi:arrow-left" />}
                                onClick={() => navigate(-1)}
                            >
                                Kembali
                            </Button>
                            <Button
                                sx={{ ml: 2 }}
                                variant="contained"
                                color="primary"
                                startIcon={<Icon icon="mdi:upload" />}
                                onClick={() => navigate('/omni/history-chat/import')}
                            >
                                Import
                            </Button>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={4}>
                                <Autocomplete
                                    options={listCustomer}
                                    value={customer}
                                    isOptionEqualToValue={(opt, val) => opt.customer_id === val.customer_id}
                                    getOptionLabel={(o) =>
                                        `${o?.customer_id ?? ''} | ${o?.customer_name ?? ''}`
                                    }
                                    filterOptions={(options, { inputValue }) => {
                                        const keyword = inputValue.toLowerCase()

                                        return options.filter((o) =>
                                            `${o?.customer_id ?? ''}`
                                                .toLowerCase()
                                                .includes(keyword) ||
                                            `${o?.customer_name ?? ''}`
                                                .toLowerCase()
                                                .includes(keyword)
                                        )
                                    }}
                                    onChange={(_, val) => setCustomer(val)}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Customer" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        disabled={customer == null ? true : false}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData()}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                        {/* DATA GRID */}
                        <MsiDatagrid array={listData} />

                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}